/**
 * Menus moved to Business Admin. Keep this path as a redirect so old bookmarks work.
 */
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/admin/menus")({
  beforeLoad: () => {
    throw redirect({ to: "/business-admin", search: { tab: "menus" } });
  },
});
